/*
 * Public API Surface of mtm-dds-api
 */
export { DcDdsApi } from './lib/dc-dds-api.service';

export { V1 as DcDdsObjectModelV1 } from './lib/Objects/Models/V1';
